<h1>Dealership</h1>
<a routerLink="addDealer" class="btn btn-sm btn-primary mb-2 me-2">Add Dealership</a>
<a routerLink="add" class="btn btn-sm btn-success mb-2">Add User</a> 
<form [formGroup]="form">
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="dealerId" class="form-label">Dealer Id</label>
            <input type="text" formControlName="dealerId" class="form-control" />
        </div>
        <div class="mb-3 col">
            <label for="dealerName" class="form-label">Dealer Name</label>
            <input type="text" formControlName="dealerName" class="form-control" />
        </div>
        <div class="mb-3 col">
            <label for="dealerGroupName" class="form-label">Group Name</label>
            <input type="text" formControlName="dealerGroupName" class="form-control" />
        </div>
        <div class="mb-3 col">
            <label for="dealerCity" class="form-label"> Dealer City</label>
            <input type="text" formControlName="dealerCity" class="form-control" />
        </div>
        <div class="mb-3 col">
            <label for="dealerState" class="form-label"> Dealer State</label>
            <input type="text" formControlName="dealerState" class="form-control" />
        </div>
        <div class="mb-3 col">
            <label for="dealerType" class="form-label"> Dealer Type</label>
            <select
            class="form-select"
            formControlName="dealerType"
          >
            <option
              *ngFor="let selectOption of ['Summary','Package','All']"
              [ngValue]="selectOption"
            >
              {{ selectOption }}
            </option>
          </select>
        </div>
    </div>

    <div class="row g-3">
        <div class="mb-3 col">
<div class="table-responsive">
<table class="table table-striped table-hover" aria-label="Dealer list">
    <thead>
        <tr>
            <th scope="col">Dealer Id</th>
            <th scope="col">Dealer Name</th>
            <th scope="col">Group Name</th>
            <th scope="col">Dealer City</th>
            <th scope="col">Dealer State</th>
            <th scope="col">Contact</th>
            <th scope="col">Edit</th>
            <th scope="col">Add User</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let dealer of dealers">
            <td>{{dealer.dealerId}}</td>
            <td>{{dealer.dealerName}}</td>
            <td>{{dealer.dealerGroupName}}</td>
            <td>{{dealer.dealerCity}}</td>
            <td>{{dealer.dealerState}}</td>
            <td>{{dealer.dealerContactNumber}}</td>
            <td style="white-space: nowrap">
                <a routerLink="editDealer/{{dealer.dealerId}}" class="btn btn-sm btn-primary me-1" [attr.aria-label]="'Edit dealer ' + dealer.dealerName">Edit</a>
            </td>
            <td style="white-space: nowrap">
                <a routerLink="add/{{dealer.dealerId}}" class="btn btn-sm btn-success me-1" [attr.aria-label]="'Add user for dealer ' + dealer.dealerName">Add User</a>
            </td>
        </tr>
        <tr *ngIf="isLoading">
            <td colspan="8" class="text-center">
                <span class="spinner-border spinner-border-lg align-center"></span>
            </td>
        </tr>
        <tr *ngIf="!isLoading && (!dealers || dealers.length === 0)">
            <td colspan="8" class="text-center py-4 text-muted">
                <i class="fa fa-inbox fa-2x d-block mb-2"></i>
                No records found.
            </td>
        </tr>
    </tbody>
</table>
</div>
</div>
</div>
</form>
